import { ReportEventLocations, ReportReader } from '@ardoq/report-reader';
import { getComponentLinkHandler } from 'report/ReportReader/utils';
import { connect } from '@ardoq/rxbeach';
import { reportSlideViewModel$ } from './reportSlideViewModel$';
import { ReportSlideProps } from './types';
import { ArdoqId } from '@ardoq/api-types';
import { HtmlSlideCaptureSurface } from './HtmlSlideCaptureSurface';

const ReportSlideBase = ({ capture, ...props }: ReportSlideProps) => (
  <HtmlSlideCaptureSurface capture={capture}>
    <ReportReader
      canDrilldownIntoDiscover={false}
      isExportingDisabled={true}
      reportReaderLocation={ReportEventLocations.PRESENTATION}
      getComponentLinkHandler={(componentId: ArdoqId) =>
        getComponentLinkHandler(componentId, props.i18nLocale)
      }
      {...props}
    />
  </HtmlSlideCaptureSurface>
);

export const ReportSlide = connect(ReportSlideBase, reportSlideViewModel$);
